<template>
    <div class="global-tabs global-tabs--vue">
        <global-filter-list v-if="headerType === 'filter'"
                            :filter-label="filterLabel"
                            :options="tabOptions"
                            :active="currentTabIndex"
                            :always-show-filter-label="true"
                            @select="selectTab($event.value)" />
        <ul v-else class="global-tabs__navigation list--exempt">
            <li v-for="(tab, index) in tabs">
                <a class="global-tabs__title" :class="[headerTypeClass, {'tab-active': index === currentTabIndex}]" @click="selectTab(index)">{{ tab.header || 'Tab ' + (index+1) }}</a>
            </li>
        </ul>
        <slot />
    </div>
</template>

<script>
import GlobalFilterList from '../global-filter-list/global-filter-list.vue';

export const propOptions = {
    headerType: ['filter', 'headline-2', 'headline-3']
}

export default {
    name: "global-tabs",
    components: { GlobalFilterList },
    props: {
        headerType: {
            type: String,
            default: propOptions.headerType[0],
            validator: function (value) {
                return propOptions.headerType.indexOf(value) !== -1;
            }
        }
    },
    data: function () {
        return {
            filterLabel: 'Tabs',
            currentTabIndex: 0,
            tabs: []
        }
    },
    provide() {
        const tabData = {
            tabs: this.tabs
        };

        // this.tabs is reactive as it's an array; currentTabIndex is ony a primitive, thus not reactive per default
        // Man kann zwar in tabData auch direkt "currentTabIndex: () => this.currentTabIndex" schreiben, dann muss man aber beim injecteden auch mit () aufrufen...
        Object.defineProperty(tabData, "currentTabIndex", {
            // enumerable: true,
            get: () => this.currentTabIndex,
        });

        return {
            tabData: tabData
        }
    },
    computed: {
        headerTypeClass() {
            switch (this.headerType) {
                case 'headline-2':
                    return 'headline-2';
                case 'headline-3':
                    return 'headline-3';
                default:
                    return 'headline-2'
            }
        },
        tabOptions() {
            if (this.headerType !== 'filter' || !this.tabs) {
                return null;
            }

            return this.tabs.map((tab, i) => {
                return {
                    value: i, // Muss der Index sein!
                    title: tab.header || 'Tab ' + (i+1)
                }
            });
        },
    },
    methods: {
        selectTab(tabIndex) {
            if (this.currentTabIndex !== tabIndex.value) {
                this.$emit('tabchanged', tabIndex.value);
            }

            this.currentTabIndex = tabIndex
        }
    }
}
</script>
